<template>
  <p>Saindo...</p>
</template>
<script>
export default {
  beforeMount() {
    this.$auth.logout({
      redirect: {name: 'login'},
    });
  },
};
</script>
